import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const divider = css`
  margin-top: ${size[48]};
  margin-bottom: ${size[48]};

  ${breakpoint.up('md')} {
    margin-top: ${size[64]};
    margin-bottom: ${size[64]};
  }
`
